import { render, staticRenderFns } from "./paymentCard.vue?vue&type=template&id=055d6b84&scoped=true"
import script from "./paymentCard.vue?vue&type=script&lang=js"
export * from "./paymentCard.vue?vue&type=script&lang=js"
import style0 from "./paymentCard.vue?vue&type=style&index=0&id=055d6b84&prod&lang=less"
import style1 from "./paymentCard.vue?vue&type=style&index=1&id=055d6b84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d6b84",
  null
  
)

export default component.exports